import { styled } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const StyledCheckboxGroup = styled(
  "div",
  shouldNotForwardProps(["row"])
)`
  position: relative;
  display: flex;
  gap: 12px 24px;
  flex-direction: ${({ row }) => row ? "row" : "column"};
`, GroupMessageStyled = styled(
  "span",
  shouldNotForwardProps(["isError"])
)`
  color: ${({ theme, isError }) => isError ? theme.palette.error.main : theme.palette.grey[500]};
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  margin-top: 12px;
`;
export {
  GroupMessageStyled,
  StyledCheckboxGroup
};
//# sourceMappingURL=styles.js.map
